export default __webpack_public_path__ + "static/media/arrow-right-green.acaa3731.svg";